import Ofac from "../scopes/Ofac";

export const dbMapping = {
  BasicDetails: 'case_employee_data',
  Address: 'case_address_bgv',
  DigitalAddress: 'case_digitalAddress_bgv',
  CreditCheck: 'case_creditCheck_bgv',
  CibilCheck: 'case_cibilCheck_bgv',
  Criminal: 'case_criminal_bgv',
  DatabaseCheck: 'case_globalDB_bgv',
  DrugTest: 'case_drugTest_bgv',
  OFAC: 'case_ofac_bgv',
  Education: 'case_education_bgv',
  Employment: 'case_employment_bgv',
  BankStatement: 'case_bankStatement_bgv',
  Identification: 'case_id_bgv',
  GapVerification: 'case_gap_bgv',
  UanCheck: 'case_uan_bgv',
  Reference: 'case_reference_bgv',
  CompanyCheck: 'case_company_bgv',
  CvValidation: 'case_cv_bgv',
  DirectorshipCheck: 'case_directorship_bgv',
  PoliceVerification: 'case_police_bgv',
  SocialMedia: 'case_socialmedia_bgv'
};

export const dbMappingReverse = {
  case_employee_data: 'BasicDetails',
  case_address_bgv: 'Address',
  case_creditCheck_bgv: 'CreditCheck',
  case_cibilCheck_bgv: 'CibilCheck',
  case_criminal_bgv: 'Criminal',
  case_globalDB_bgv: 'DatabaseCheck',
  case_drugTest_bgv: 'DrugTest',
  case_ofac_bgv: 'OFAC',   // newly added
  case_education_bgv: 'Education',
  case_employment_bgv: 'Employment',
  case_id_bgv: 'Identification',
  case_gap_bgv: 'GapVerification',
  case_reference_bgv: 'Reference',
  case_company_bgv: 'CompanyCheck',
  case_cv_bgv: 'CvValidation',
  case_directorship_bgv: 'DirectorshipCheck',
  case_police_bgv: 'PoliceVerification',
  case_socialmedia_bgv: 'SocialMedia'
};

export const InvoiceReportMapping = {
  case_address_bgv_1: 'Address 1',
  case_address_bgv_2: 'Address 2',
  case_address_bgv_3: 'Address 3',
  case_address_bgv_4: 'Address 4',

  case_digitalAddress_bgv_1: 'Digital Address 1',
  case_digitalAddress_bgv_2: 'Digital Address 2',
  case_digitalAddress_bgv_3: 'Digital Address 3',
  case_digitalAddress_bgv_4: 'Digital Address 4',

  case_creditCheck_bgv: 'Credit Check',
  case_cibilCheck_bgv: 'Cibil Check',

  case_criminal_bgv_1: 'Criminal 1',
  case_criminal_bgv_2: 'Criminal 2',

  case_globalDB_bgv: 'Database Check',
  case_drugTest_bgv: 'Drug Test',
  case_ofac_bgv: 'OFAC',   // newly added

  case_education_bgv_1: 'Education 1',
  case_education_bgv_2: 'Education 2',
  case_education_bgv_3: 'Education 3',

  case_employment_bgv_1: 'Employment 1',
  case_employment_bgv_2: 'Employment 2',
  case_employment_bgv_3: 'Employment 3',
  case_employment_bgv_4: 'Employment 4',
  case_employment_bgv_5: 'Employment 5',
  case_employment_bgv_6: 'Employment 6',
  case_employment_bgv_7: 'Employment 7',
  case_employment_bgv_8: 'Employment 8',
  case_employment_bgv_9: 'Employment 9',
  case_employment_bgv_10: 'Employment 10',
  case_employment_bgv_11: 'Employment 11',
  case_employment_bgv_12: 'Employment 12',
  case_employment_bgv_13: 'Employment 13',
  case_employment_bgv_14: 'Employment 14',
  case_employment_bgv_15: 'Employment 15',

  case_id_bgv_1: 'Identification 1',
  case_id_bgv_2: 'Identification 2',
  case_id_bgv_3: 'Identification 3',
  case_id_bgv_4: 'Identification 4',
  case_id_bgv_5: 'Identification 5',
  case_id_bgv_6: 'Identification 6',

  case_gap_bgv: 'Gap Verification',
  case_gap_bgv_1: 'Gap Verification 1',
  case_gap_bgv_2: 'Gap Verification 2',
  case_gap_bgv_3: 'Gap Verification 3',
  case_gap_bgv_4: 'Gap Verification 4',
  case_gap_bgv_5: 'Gap Verification 5',
  case_gap_bgv_6: 'Gap Verification 6',
  case_gap_bgv_7: 'Gap Verification 7',
  case_gap_bgv_8: 'Gap Verification 8',
  case_gap_bgv_9: 'Gap Verification 9',
  case_gap_bgv_10: 'Gap Verification 10',

  case_reference_bgv_1: 'Reference 1',
  case_reference_bgv_2: 'Reference 2',
  case_reference_bgv_3: 'Reference 3',

  case_company_bgv: 'Company Check',
  case_cv_bgv: 'Cv Validation',
  case_directorship_bgv: 'Directorship Check',
  case_police_bgv: 'Police Verification',
  case_socialmedia_bgv: 'Social Media',
  case_uan_bgv: 'Uan Check',
  case_bankStatement_bgv: 'Bank Statement',

  case_education_bgv_1_additionalCost: 'Education 1 (Add. Cost)',
  case_education_bgv_2_additionalCost: 'Education 2 (Add. Cost)',
  case_education_bgv_3_additionalCost: 'Education 3 (Add. Cost)',
  case_employment_bgv_1_additionalCost: 'Employment 1 (Add. Cost)',
  case_employment_bgv_2_additionalCost: 'Employment 2 (Add. Cost)',
  case_employment_bgv_3_additionalCost: 'Employment 3 (Add. Cost)',
  case_employment_bgv_4_additionalCost: 'Employment 4 (Add. Cost)',
  case_employment_bgv_5_additionalCost: 'Employment 5 (Add. Cost)',
  case_employment_bgv_6_additionalCost: 'Employment 6 (Add. Cost)',
  case_employment_bgv_7_additionalCost: 'Employment 7 (Add. Cost)',
  case_employment_bgv_8_additionalCost: 'Employment 8 (Add. Cost)',
  case_employment_bgv_9_additionalCost: 'Employment 9 (Add. Cost)',
  case_employment_bgv_10_additionalCost: 'Employment 10 (Add. Cost)',
  case_employment_bgv_11_additionalCost: 'Employment 11 (Add. Cost)',
  case_employment_bgv_12_additionalCost: 'Employment 12 (Add. Cost)',
  case_employment_bgv_13_additionalCost: 'Employment 13 (Add. Cost)',
  case_employment_bgv_14_additionalCost: 'Employment 14 (Add. Cost)',
  case_employment_bgv_15_additionalCost: 'Employment 15 (Add. Cost)',
};

// Label
export const bgvStatus = {
  Awaiting: 'Awaiting',
  Wip: 'Work in progress',
  UnableToVerify: 'Unable to verify',
  Discrepancy: 'Discrepancy',
  Completed: 'Completed',
  Insufficient: 'Insufficiency',
  BgvStop: 'BGV stop',
  NotProvided: 'Not provided',
  PartiallyCompleted: 'Partially completed',
  QCYetToStart: "Yet To Start",
  OverAllCases: "Overall Cases",
  YetToDo: "Partially Completed",
  QCCompleted: 'QC Completed',
  InsuffCleared: 'Insuff Cleared',
};

// Label v2
export const bgvStatusV2 = {
  Awaiting: 'Awaiting',
  Wip: 'WIP',
  UnableToVerify: 'UnableToVerify',
  Discrepancy: 'Discrepancy',
  Completed: 'Completed',
  Insufficient: 'InSufficient',
  BgvStop: 'BgvStop',
  QCYetToStart: "YetToStart",
  OverAllCases: "OverallCases",
  YetToDo: "PartiallyCompleted",
  QCCompleted: 'QCCompleted',
};

// Values
export const bgvStatusValues = {
  Awaiting: 'Awaiting',
  Wip: 'WIP',
  UnableToVerify: 'UnableToVerify',
  Discrepancy: 'Discrepancy',
  Completed: 'Completed',
  Insufficient: 'InSufficient',
  BgvStop: 'BgvStop',
  NotProvided: 'NotProvided',
  PartiallyCompleted: 'PartiallyCompleted',
  QCYetToStart: "YetToStart",
  OverAllCases: "OverallCases",
  YetToDo: "PartiallyCompleted",
  QCCompleted: 'QCCompleted',
  InsuffCleared: 'InsuffCleared',
};

// Label
export const reportStatusOptions = {
  Awaiting: 'Awaiting',
  interimQcReview: 'Interim QC Review',
  interimQcApproved: 'Interim QC Approved',
  interimQcRejected: 'Interim QC Rejected',
  finalQcReview: 'Final QC Review',
  finalQcApproved: 'Final QC Approved',
  finalQcRejected: 'Final QC Rejected'
};

// Values
export const reportStatusOptionsValues = {
  totalInterimReports: 'Awaiting',
  totalFinalReports: 'WIP',
  approvedInterimReports: 'Unable to verify',
  approvedFinalReports: 'Discrepancy',
  rejectedInterimReports: 'Completed',
  rejectedFinalReports: 'InSufficient'
};

export const addressTypesDbMapping = {
  PhysicalOnly: 1,
  DigitalOnly: 2,
  Both: 3
};

export const davStatusLabels = {
  Awaiting: 'Awaiting',
  Wip: 'Work in progress',
  Submitted: 'Submitted',
  ReInitiated: 'Re Initiated',
  Completed: 'Completed',
  UnableToVerify: 'Unable to verify',
  Discrepancy: 'Discrepancy',
  Insufficient: 'Insufficiency',
  Saved: 'Saved'
};

export const davStatusValues = {
  Awaiting: 'Awaiting',
  Wip: 'WIP',
  Submitted: 'Submitted',
  Completed: 'Completed',
  ReInitiated: 'ReInitiated',
  UnableToVerify: 'UnableToVerify',
  Discrepancy: 'Discrepancy',
  Insufficient: 'InSufficient'
};

export const davAddressTypes = {
  Permanent: 'permanentAddress',
  Current: 'currentAddress',
  IntermediateOne: 'intermediateAddressOne',
  IntermediateTwo: 'intermediateAddressTwo'
};
